<template>
  <v-layout class="xs-d-block" wrap>
    <template v-if="match.adminMode || match.viewerMode">
      <v-flex xs12>
        {{ $t('page.match.downloadStats') }}
        <a @click="downloadStatsExcel">{{ $t('page.match.downloadStatsExcel') }}</a>
        {{ $t('page.match.downloadStatsOr') }}
        <a @click="downloadStatsPdf">{{ $t('page.match.downloadStatsPDF') }}</a>
      </v-flex>
      <v-flex xs12>
        <v-layout id="statsByPlayer" ref="statsByPlayer" wrap row>
          <!-- TOTAL -->
          <v-flex v-for="team in ['l', 'v']" :key="`person_total_stats_team_${team}`" xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <h3 v-if="team === 'l'">{{ match.localTeam }}</h3>
                <h3 v-else>{{ match.visitorTeam }}</h3>
              </v-flex>
              <v-flex xs12>
                <table :ref="`table_total_${team}`" class="sets-summary table-responsive">
                  <tbody>
                    <tr>
                      <th :colspan="match.pointControls.length + 4" class="white">
                        {{ $t('page.match.total') }}
                      </th>
                    </tr>
                    <tr>
                      <th class="white" rowspan="2"><span /></th>
                    </tr>
                    <tr>
                      <th>
                        {{ $t('page.match.appreciation') }}
                      </th>
                      <th>
                        {{ $t('page.match.positives') }}
                      </th>
                      <th>
                        {{ $t('page.match.negatives') }}
                      </th>
                      <th v-for="(column, j) in match.pointControls" :key="`set_h2_total_${j}`">
                        {{ $t(`sport.controls.${column.code}.short`) }}
                      </th>
                    </tr>
                    <tr
                      v-for="(player, playerKey) in match.setsTableData.playersStats.total[team]"
                      :key="`player_${team}_${playerKey}`"
                    >
                      <th>{{ playerKey }}</th>
                      <td>{{ player.positives - player.negatives }}</td>
                      <td>{{ player.positives }}</td>
                      <td>{{ player.negatives }}</td>
                      <td v-for="(column, j) in match.pointControls" :key="`set_l_total_${j}`">
                        {{ player.events[column.code] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
              <v-flex
                v-for="(set, i) in match.sets"
                v-if="i < 1 || (set.events && set.events.length > 0)"
                :key="`set_h1_${i}`"
                xs12
              >
                <table class="sets-summary table-responsive">
                  <tbody>
                    <tr>
                      <th :colspan="match.pointControls.length + 4" class="white">
                        {{ match.setText }}
                        {{ i + 1 }}
                      </th>
                    </tr>
                    <tr>
                      <th class="white" rowspan="2"><span /></th>
                    </tr>
                    <tr>
                      <th>
                        {{ $t('page.match.appreciation') }}
                      </th>
                      <th>
                        {{ $t('page.match.positives') }}
                      </th>
                      <th>
                        {{ $t('page.match.negatives') }}
                      </th>
                      <th v-for="(column, j) in match.pointControls" :key="`set_h2_${i}_${j}`">
                        {{ $t(`sport.controls.${column.code}.short`) }}
                      </th>
                    </tr>
                    <tr
                      v-for="(player, playerKey) in match.setsTableData.playersStats.sets[i][team]"
                      :key="`player_${team}_${playerKey}`"
                    >
                      <th>{{ playerKey }}</th>
                      <td>{{ player.positives - player.negatives }}</td>
                      <td>{{ player.positives }}</td>
                      <td>{{ player.negatives }}</td>
                      <td
                        v-for="(column, j) in match.pointControls"
                        :key="`set_l_${i}_${playerKey}_${j}`"
                      >
                        {{ player.events[column.code] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
    <template v-else>
      <v-alert
        :value="true"
        outline
        color="success"
        v-html="$t('page.match.onlyClubUsersDisclaimer')"
      />
    </template>
  </v-layout>
</template>

<script>
import XLSX from 'xlsx'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from 'pdfmake/build/vfs_fonts.js'
const debug = require('debug')('OD::PlayerStats')

export default {
  name: 'PlayerStats',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {
    createTeamInfo() {
      const table = []
      table.push([this.$t('entity.match.localTeam.label'), this.match.localTeam])
      table.push([this.$t('entity.match.visitorTeam.label'), this.match.visitorTeam])
      table.push([this.$t('entity.match.date.label'), this.match.date])
      table.push([this.$t('entity.match.category.label'), this.match.category])
      table.push([this.$t('entity.match.day.label'), this.match.day])
      table.push([this.$t('entity.match.location.label'), this.match.location])
      table.push([
        this.$t('page.match.result'),
        this.match.totalScoreLocal + ' - ' + this.match.totalScoreVisitor,
      ])
      this.match.sets.forEach((set, i) => {
        if (set.l > 0 && set.v > 0) {
          table.push([this.match.setText + ' ' + (i + 1), set.l + ' - ' + set.v])
        }
      })
      return table
    },
    createTeamInfoSheet(wb) {
      const sheetName = 'info'
      const table = this.createTeamInfo()
      const ws = XLSX.utils.aoa_to_sheet(table)
      XLSX.utils.book_append_sheet(wb, ws, `${sheetName}`)
    },
    createTeamInfoPDF(content) {
      const table = this.createTeamInfo()
      content.push({
        table: {
          headerRows: 1,
          style: 'tableStats',
          body: table,
        },
      })
    },
    createTeamTotal(team) {
      // Headers
      const headers = [
        '',
        this.$t('page.match.appreciation'),
        this.$t('page.match.positives'),
        this.$t('page.match.negatives'),
      ]
      this.match.pointControls.forEach(column => {
        headers.push(this.$t(`sport.controls.${column.code}.short`))
      })
      const table = [headers]
      // Players
      debug('aa', {
        setsTableData: this.match.setsTableData.playersStats.total,
        team,
      })
      Object.keys(this.match.setsTableData.playersStats.total[team]).forEach(playerKey => {
        const player = this.match.setsTableData.playersStats.total[team][playerKey]
        const data = [
          playerKey,
          player.positives - player.negatives,
          player.positives,
          player.negatives,
        ]
        this.match.pointControls.forEach(column => {
          data.push(player.events[column.code])
        })
        table.push(data)
      })
      return table
    },
    createTeamTotalSheet(wb, team) {
      const sheetName =
        team === 'l'
          ? this.$t('page.match.total') + ' - Local - ' + this.match.localTeam
          : this.$t('page.match.total') + ' - Visitor - ' + this.match.visitorTeam
      const table = this.createTeamTotal(team)
      const ws = XLSX.utils.aoa_to_sheet(table)
      XLSX.utils.book_append_sheet(wb, ws, `${sheetName}`)
    },
    createTeamTotalPDF(content, team) {
      const title =
        team === 'l'
          ? this.$t('page.match.total') + ' - ' + this.match.localTeam
          : this.$t('page.match.total') + ' - ' + this.match.visitorTeam

      const table = this.createTeamTotal(team)
      content.push({
        text: title,
        style: 'header',
      })
      content.push({
        table: {
          style: 'tableStats',
          headerRows: 1,
          body: table,
        },
      })
    },
    createTeamSet(team, i) {
      const headers = [
        '',
        this.$t('page.match.appreciation'),
        this.$t('page.match.positives'),
        this.$t('page.match.negatives'),
      ]
      this.match.pointControls.forEach(column => {
        headers.push(this.$t(`sport.controls.${column.code}.short`))
      })
      const table = [headers]
      // Players
      debug('aa', {
        setsTableData: this.match.setsTableData.playersStats.total,
        team,
      })
      Object.keys(this.match.setsTableData.playersStats.sets[i][team]).forEach(playerKey => {
        const player = this.match.setsTableData.playersStats.sets[i][team][playerKey]
        const data = [
          playerKey,
          player.positives - player.negatives,
          player.positives,
          player.negatives,
        ]
        this.match.pointControls.forEach(column => {
          data.push(player.events[column.code])
        })
        table.push(data)
      })
      return table
    },
    createTeamSetSheet(wb, team, i) {
      const sheetName =
        team === 'l'
          ? this.match.setText + (i + 1) + ' - Local - ' + this.match.localTeam
          : this.match.setText + (i + 1) + ' - Visitor - ' + this.match.visitorTeam
      const table = this.createTeamSet(team, i)
      const ws = XLSX.utils.aoa_to_sheet(table)
      XLSX.utils.book_append_sheet(wb, ws, `${sheetName}`)
    },
    createTeamSetPDF(content, team, i) {
      const title =
        team === 'l'
          ? this.match.setText + (i + 1) + ' - ' + this.match.localTeam
          : this.match.setText + (i + 1) + ' - ' + this.match.visitorTeam
      const table = this.createTeamSet(team, i)
      content.push({
        text: title,
        style: 'subheader',
      })
      content.push({
        table: {
          headerRows: 1,
          body: table,
        },
      })
    },
    createTeamSheet(wb, team) {
      this.createTeamTotalSheet(wb, team)
      this.match.sets.forEach((set, i) => {
        if (i < 1 || (set.events && set.events.length > 0)) {
          this.createTeamSetSheet(wb, team, i)
        }
      })
    },
    createTeamPDF(content, team) {
      this.createTeamTotalPDF(content, team)
      this.match.sets.forEach((set, i) => {
        if (i < 1 || (set.events && set.events.length > 0)) {
          this.createTeamSetPDF(content, team, i)
        }
      })
    },
    createExcelFile() {
      debug('createExcelFile')
      const wb = XLSX.utils.book_new()
      this.createTeamInfoSheet(wb)
      const teams = ['l', 'v']
      teams.map(team => {
        this.createTeamSheet(wb, team)
      })
      return wb
    },
    downloadStatsExcel() {
      debug('downloadStatsExcel')
      const wb = this.createExcelFile()
      const wopts = { bookType: 'xlsx', type: 'array' }
      const data = XLSX.write(wb, wopts)
      const link = document.createElement('a')
      const blob = new Blob([data], { type: 'application/octet-stream' })
      link.href = window.URL.createObjectURL(blob)
      link.download = `${this.match.localTeam} vs ${this.match.visitorTeam}.xlsx`
      link.click()
    },
    downloadStatsPdf() {
      debug('downloadStatsPdf')
      debug('pdfMake', pdfMake)
      const generatedBy = 'Generated by SigueTuClub.com'
      const content = []
      content.push({
        text: generatedBy,
        style: 'footer',
      })
      this.createTeamInfoPDF(content)
      const teams = ['l', 'v']
      teams.map(team => {
        this.createTeamPDF(content, team)
      })
      content.push({
        text: generatedBy,
        style: 'footer',
      })
      const docDefinition = {
        content: content,
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableStats: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black',
          },
          footer: {
            fontSize: 12,
            color: 'grey',
            italic: true,
            alignment: 'right',
            margin: [0, 15, 0, 15],
          },
        },
      }
      debug('docDefinition', docDefinition)
      const fileName = `${this.match.localTeam} vs ${this.match.visitorTeam}.pdf`
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(docDefinition).download(fileName)
    },
  },
}
</script>

<style lang="scss" scoped>
.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}
</style>
